module.exports = "<div ng-repeat=\"element in elements\" jqyoui-droppable drop=\"true\">\n    <div sgcontenteditor-editor-element-render \n         editor=\"editor\" element=\"element\" tabdepth=\"tabdepth\" pageid=\"pageid\"\n         class=\"sgcontenteditor-element\" id=\"Element-{{element.element_id}}\" \n         bg-img=\"{{element.data.bgimg}}\" ng-class=\"element.data.class\"\n         ></div>\n    <style ng-if=\"element.data.cssitems && element.data.cssitems.length\" ng-bind-html=\"GetStyle(element)\"></style>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./sgcontenteditor/sgcontenteditorAdmin/directives/elementsDisplay.html
// module id = 359
// module chunks = 0